import { render } from "./SaveFilterModal.vue?vue&type=template&id=5c59f7bc&scoped=true"
import script from "./SaveFilterModal.vue?vue&type=script&lang=js"
export * from "./SaveFilterModal.vue?vue&type=script&lang=js"

import "./SaveFilterModal.vue?vue&type=style&index=0&id=5c59f7bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c59f7bc"]])

export default __exports__